import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { CommonUtilService } from '../service/common-util.service';
import { LargereceiptService } from '../service/largereceipt.service';
@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {
  messageId!: string;
  historyId:string;
  constructor(private route: ActivatedRoute,private router:Router
    ,private largeReceiptService:LargereceiptService
    ,private commonUtilSvc: CommonUtilService
    ) { 
    
        router.events.subscribe((val) => {
          if (val instanceof NavigationStart) {
            // Show loading indicator
          //alert('session'+localStorage.getItem("MessageId"));
          //alert('msgid' + this.messageId)
          /* if(localStorage.getItem("MessageId")!=undefined && this.messageId==undefined)
          {
            this.messageId=localStorage.getItem("MessageId");
          }
          else
          {
            this.route.params.subscribe( params => this.messageId=(params.messageId));
            localStorage.setItem("MessageId",this.messageId);

          } */

        }

        
    });


    
  }

  ngOnInit(): void {
    
    
    if(localStorage.getItem("HistoryId")!=undefined)
    {
      this.historyId=localStorage.getItem("HistoryId");
      
    }
    //alert('localstorage'+ localStorage.getItem("MessageId"));
    //this.route.params.subscribe( params => this.messageId=(params.messageId));
  }

  NavigateToScreen(screenName)
  {
        if(localStorage.getItem("MessageId")!=undefined && this.messageId==undefined)
          {
            this.messageId=localStorage.getItem("MessageId");
          }
          /* else
          {
            this.route.params.subscribe( params => this.messageId=(params.messageId));
            localStorage.setItem("MessageId",this.messageId);

          } */
    this.commonUtilSvc.DisplayAndHideSideMenu(screenName);
    
      if(this.router.url.indexOf(screenName)==-1)
          this.commonUtilSvc.showSpinner();
      
    
      if(screenName=='receipts/retrieve' || screenName=='receipt-authentication' ) 
      {
        if(this.messageId!=undefined)
          this.router.navigate(['/'+screenName,this.messageId]);
        else 
          this.router.navigate(['/'+screenName]);
      }
      else
      {
        //alert(this.historyId);
        if(this.historyId!=undefined)
          this.router.navigate(['/'+screenName,this.historyId]);
        else
          this.router.navigate(['/'+screenName]);
          
      }
    

  }

}
